// extracted by mini-css-extract-plugin
module.exports = {"title":"_2hvNobZFYT","tall":"NgJSU8IEa6"};
    if(module.hot) {
      // 1614934686042
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  